import { SnapshotAlarmSettingForm } from '../types';

export const restoreSettingsDefaults = (
  oldSettings: SnapshotAlarmSettingForm
) => {
  const settings = { ...oldSettings };
  settings.raising_count = settings.raising_count
    ? settings.raising_count
    : 3000;
  settings.ignore_interval = settings.ignore_interval
    ? settings.ignore_interval
    : 5;
  settings.ignore_interval_unit =
    settings.ignore_interval_unit === null ||
    settings.ignore_interval_unit === undefined
      ? 2
      : settings.ignore_interval_unit;
  settings.email_port = settings.email_port ? settings.email_port : 465;
  settings.snmp_port = settings.snmp_port ? settings.snmp_port : 162;
  settings.snmp_community = settings.snmp_community
    ? settings.snmp_community
    : 'public';
  settings.snmp_version =
    settings.snmp_version === null || settings.snmp_version === undefined
      ? 0
      : settings.snmp_version;
  return settings;
};
